import Swiper from 'swiper';
import {Autoplay} from 'swiper/modules';

function initCertificatesSlider() {
  const containers = document.querySelectorAll('.wp-block-lb-main-hero');
  if (!containers.length) return;

  containers.forEach((container) => {
    const slider = container.querySelector('.js-logos-slider');
    if (!slider) return;

    if (slider.swiper) {
      slider.swiper.update();
      slider.swiper.autoplay.start();
      return;
    }

    new Swiper(slider, {
      modules: [Autoplay],
      spaceBetween: 64,
      direction: "horizontal",
      freeMode: true,
      zoom: true,
      loop: true,
      speed: 5000,
      autoplay: {
        delay: 0,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
        },
        640: {
          slidesPerView: 3,
        },
        810: {
          slidesPerView: 4,
        },
        1080: {
          slidesPerView: 5,
        }
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initCertificatesSlider);
window.addEventListener('resize', () => {
  document.querySelectorAll('.js-logos-slider').forEach((slider) => {
    if (slider.swiper) {
      slider.swiper.update();
      slider.swiper.autoplay.start();
    }
  });
});
